module.exports = __webpack_public_path__ + "static/img/5.48e84aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/5.png
// module id = YCxX
// module chunks = 0